import { tap } from 'rxjs';

import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'back-icon',
  standalone: true,
  imports: [],
  template: `
    <div class="svg-container cursor-pointer" (click)="rotateSvg()">
      <svg
        [class.rotated]="isRotated()"
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <!-- Box -->
        <path
          d="M18.25 0.75H1.75C1.35218 0.75 0.970644 0.908035 0.68934 1.18934C0.408035 1.47064 0.25 1.85218 0.25 2.25V15.75C0.25 16.1478 0.408035 16.5294 0.68934 16.8107C0.970644 17.092 1.35218 17.25 1.75 17.25H18.25C18.6478 17.25 19.0294 17.092 19.3107 16.8107C19.592 16.5294 19.75 16.1478 19.75 15.75V2.25C19.75 1.85218 19.592 1.47064 19.3107 1.18934C19.0294 0.908035 18.6478 0.75 18.25 0.75ZM1.75 2.25H5.5V15.75H1.75V2.25ZM18.25 15.75H7V2.25H18.25V15.75Z"
          fill="#27272A" />
        <!-- Arrow -->
        <path
          d="M16.2803 9.42284C16.421 9.28218 16.5 9.09142 16.5 8.89251C16.5 8.69359 16.421 8.50283 16.2803 8.36218C16.1397 8.22152 15.9489 8.14251 15.75 8.14251H11.0603L12.7806 6.42313C12.9213 6.2824 13.0004 6.09153 13.0004 5.89251C13.0004 5.69348 12.9213 5.50261 12.7806 5.36188C12.6399 5.22115 12.449 5.14209 12.25 5.14209C12.051 5.14209 11.8601 5.22115 11.7194 5.36188L8.71935 8.36188C8.64962 8.43154 8.5943 8.51425 8.55656 8.6053C8.51882 8.69635 8.49939 8.79395 8.49939 8.89251C8.49939 8.99107 8.51882 8.99107 8.55656 9.17971C8.5943 9.27076 8.64962 9.35348 8.71935 9.42313L11.7194 12.4231C11.789 12.4928 11.8718 12.5481 11.9628 12.5858C12.0539 12.6235 12.1514 12.6429 12.25 12.6429C12.3485 12.6429 12.4461 12.6235 12.5372 12.5858C12.6282 12.5481 12.7109 12.4928 12.7806 12.4231C12.8503 12.3534 12.9056 12.2707 12.9433 12.1797C12.981 12.0886 13.0004 11.9911 13.0004 11.8925C13.0004 11.794 12.981 11.6964 12.9433 11.6053C12.9056 11.5143 12.8503 11.4316 12.7806 11.3619L11.0603 9.64251H15.75C15.9489 9.64251 16.1397 9.56349 16.2803 9.42284Z"
          fill="#27272A" />
      </svg>
    </div>
  `,
  styles: `
    .svg-container svg {
      transform-origin: center;
      transition: transform 0.6s ease;
      transform-style: preserve-3d;
      transform: rotateY(180deg);
    }

    .svg-container svg.rotated {
      transform: rotateY(0deg);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackIcon {
  isRotated = signal(false);
  isRotatedFromParent = input(false);
  isRotatedFromParent$ = toObservable(this.isRotatedFromParent)
    .pipe(
      takeUntilDestroyed(),
      tap(res => this.isRotated.set(res))
    )
    .subscribe();

  rotateSvg() {
    this.isRotated.set(!this.isRotated());
  }
}
